export var GridOrderDirection;
(function (GridOrderDirection) {
    /**
     * Top-to-bottom then left-to-right.
     */
    GridOrderDirection["Vertical"] = "vertical";
    /**
     * Left-to-right then top-to-bottom.
     */
    GridOrderDirection["Horizontal"] = "horizontal";
})(GridOrderDirection || (GridOrderDirection = {}));
export var GridType;
(function (GridType) {
    /**
     * Grid is generated from the center of the volume.
     */
    GridType["CenterBased"] = "center_based";
    /**
     * Grid is generated from the edge of the volume.
     */
    GridType["EdgeBased"] = "edge_based";
})(GridType || (GridType = {}));
